import React from 'react';
import cadImage from '../assets/img/images/cad1.jpg';
import cadImage1 from '../assets/img/images/cad2.jpg';

function Caddesign() {
  return (
    <div style={styles.background}>
      <h1 style={styles.heading}>Computer-Aided Design (CAD)</h1>
      <p style={styles.paragraph}>
        CAD, or Computer-Aided Design, refers to the use of computer software to create and modify 2D and 3D models of objects, structures, or designs. It's a crucial tool for architects, engineers, and other professionals, enabling them to visualize and refine their designs before physical production.
      </p>

      <div style={styles.gridContainer}>
        <section style={{ ...styles.section, backgroundColor: '#d4baff' }}>
          <img
            src={cadImage}
            alt="CAD Key Aspects"
            style={styles.image}
          />
          <h2 style={{ ...styles.subheading, color: '#fd9000' }}>Key Aspects of CAD</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Digital Representation:</strong> Enables detailed and accurate design work through digital models.</li>
            <li style={styles.listItem}><strong>2D and 3D Models:</strong> Creates both 2D drawings and 3D models for better understanding.</li>
            <li style={styles.listItem}><strong>Design Process:</strong> Supports conceptualization to detailed simulations and documentation.</li>
            <li style={styles.listItem}><strong>Efficiency and Accuracy:</strong> Improves design precision, reduces errors, and enhances speed.</li>
            <li style={styles.listItem}><strong>Collaboration and Communication:</strong> Makes sharing and teamwork easy and efficient.</li>
            <li style={styles.listItem}><strong>Industry Applications:</strong> Used in architecture, engineering, manufacturing, and entertainment.</li>
          </ul>
        </section>

        <section style={{ ...styles.section, backgroundColor: '#d4baff' }}>
          <img
            src={cadImage1}
            alt="CAD Benefits"
            style={styles.image}
          />
          <h2 style={{ ...styles.subheading, color: '#fd9000' }}>Benefits of Using CAD</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Enhanced Precision:</strong> Offers superior accuracy compared to manual drafting.</li>
            <li style={styles.listItem}><strong>Cost and Time Savings:</strong> Streamlines design, speeds prototyping, and cuts production costs.</li>
            <li style={styles.listItem}><strong>Design Flexibility:</strong> Easily modify and iterate to explore different concepts.</li>
            <li style={styles.listItem}><strong>Improved Communication:</strong> Visuals enhance clarity and collaboration among stakeholders.</li>
            <li style={styles.listItem}><strong>Automation and Integration:</strong> Integrates with CAM and other tools for automated workflows.</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

const styles = {
  background: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f9fafb',
    padding: '30px 20px',
    fontFamily: "'Poppins', sans-serif",
  },
  heading: {
    textAlign: 'center',
    color: '#7620ff',
    marginBottom: '20px',
    marginTop: '5rem',
    lineHeight: '1.2',
  },
  paragraph: {
    margin: '0 auto 30px auto',
    lineHeight: '1.6',
    color: '#555',
    padding: '0 10px',
    maxWidth:"80%"
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '20px',
    marginBottom: '30px',
    maxWidth:'80%',
    margin: "30px auto",
  },
  section: {
    padding: '0 0 20px 0',
    borderRadius: '10px',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  image: {
    width: '100%',
    height: '250px',
    objectFit: 'cover',
    objectPosition: 'center',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
  },
  subheading: {
    margin: '15px 20px 10px',
  },
  list: {
    padding: '0 20px',
    marginBottom: '15px',
    lineHeight: '1.5',
    color: '#555',
  },
  listItem: {
    marginBottom: '10px',
  },
};

export default Caddesign;
